import basicController from "servicestack/basic.controller.properties";
import labels from "emun.order/_labels";
import ServiceBus from "servicestack/service-bus";

export default class PriceCalculatorController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    $ctrl.discountPercentage = 0;
    $ctrl.cartItem.priceOverride = $ctrl.cartItem.price;
    $ctrl.labels = labels;
    $ctrl.reasons = ['','NEGOTIATED', 'FREE GOODS', 'PROMO', 'FLOOR', 'VOLUME', 'SPECIAL', $ctrl.cartItem.reasonCode];

    if ($ctrl.cartItem.reasonCode && $ctrl.cartItem.reasonCode != undefined) {
      $ctrl.reason = $ctrl.cartItem.reasonCode
    }
    
    $ctrl.bus
      .send("QueryPriceLists.json?ProductId=" + $ctrl.cartItem.productId)
      .then(function (res) {
        $ctrl.pricelists = res.data.results;
      });
  }

  calculatePrice() {
    const $ctrl = this;
    var newPrice = $ctrl.cartItem.price;
    if ($ctrl.priceList) newPrice = $ctrl.priceList.salesPrice;
    if ($ctrl.discountPercentage > 0) newPrice = newPrice - ((newPrice * $ctrl.discountPercentage) / 100);
    $ctrl.cartItem.priceOverride = Number(newPrice.toFixed(2));
    //$ctrl.cartItem.priceOverride = newPrice;
    //console.info(Number(newPrice.toFixed(2)));
    //if discount was added then add this
    $ctrl.reasons = ['NEGOTIATED', 'FREE GOODS', 'PROMO', 'FLOOR', 'VOLUME', 'SPECIAL'];
    if ($ctrl.discountPercentage > 0) {
      $ctrl.reasons = ['NEGOTIATED', 'FREE GOODS', 'PROMO', 'FLOOR', 'VOLUME', 'SPECIAL', $ctrl.discountPercentage + ' % OFF'];
      $ctrl.reason = $ctrl.discountPercentage + ' % OFF'
    }
  }

  submit() {
    const $ctrl = this;
    console.info("$ctrl.reason", $ctrl.reason);
    if ($ctrl.priceList) $ctrl.cartItem.priceListId = $ctrl.priceList.priceListId;
    if ($ctrl.savePrice) $ctrl.cartItem.isContractPrice = true;
    if ($ctrl.reason) $ctrl.cartItem.reasonCode = $ctrl.reason;
    if ($ctrl.reason == undefined) $ctrl.cartItem.reasonCode = "";
    var originalPrice = $ctrl.cartItem.price;
    $ctrl.$cart.changeOptions($ctrl.cartItem).then(res => $ctrl.$close(res));
    if ($ctrl.applyAll) {
      var otherItems = $ctrl.$cart.items.filter(c => c.price == originalPrice && c.position != $ctrl.cartItem.position);
      otherItems.forEach(function (item) {
        if ($ctrl.priceList) item.priceListId = $ctrl.priceList.priceListId;
        if ($ctrl.reason) item.reasonCode = $ctrl.reason;
        item.price = $ctrl.cartItem.price;
        item.priceOverride = $ctrl.cartItem.priceOverride;
        $ctrl.$cart.changeOptions(item);
      });
    }
  }
}
